import { cn } from '@/lib/utils';
import { TEMP_STYLES, TEMP_BASE_CLASSES, type TemperatureValue } from '@/lib/temperature';

export type Temperature = TemperatureValue | null | undefined;

interface TemperatureBadgeProps {
  value: Temperature;
  className?: string;
}

const FALLBACK_CLASSES =
  'bg-muted/40 text-muted-foreground border border-border/60';

export function TemperatureBadge({ value, className }: TemperatureBadgeProps) {
  const v = (value ?? '').toLowerCase() as TemperatureValue | '';
  const styleClass = v && TEMP_STYLES[v] ? TEMP_STYLES[v] : FALLBACK_CLASSES;
  const label = v ? String(value).toUpperCase() : '—';

  return (
    <span
      className={cn(TEMP_BASE_CLASSES, styleClass, className)}
      aria-label={v ? `Temperature: ${label}` : undefined}
    >
      {label}
    </span>
  );
}
